import React from 'react'

import _ from 'lodash'

export function getChartIconUrl(chart_code, disabled = false) {
  const tag = disabled ? 'icon_disable' : 'icon'
  return _.get(window, `__CHART_NAV_CHARTS.${chart_code}.${tag}`, '')
}

// 渲染组件图标
export default function getChartIcon(chart_code, disabled = false) {
  const iconUrl = getChartIconUrl(chart_code, disabled)
  return (
    <i className="chart-type-icon" style={{
      backgroundImage: iconUrl ? `url(${iconUrl})` : 'none',
      width: iconUrl ? '' : '10px'
    }}/>
  )
}
